



































































import Vue from 'vue';
import Component from 'vue-class-component';
import isEqual from 'lodash.isequal';
import isUndefined from 'lodash.isundefined';
import isNull from 'lodash.isnull';
import genericapi  from '../assets/ts/genericAPIAxios';
// Vue.prototype.$genericapi = genericapiinstance;

@Component
export default class EBiennialFix extends Vue {
  private licenseSpeAppId: string = '';
  private ebiennialFixedData: string = '';
  private BusinessName: string = '';
  private errors = [];
  private label = [];
  private imageFolderPath: string = '';
  private ebiennialTransactionData: any = {};

  private created() {
    console.log('Inside created of first page');
    //this.$store.commit('ebiennial/setEBiennialData', null);
    if (this.empty(this.label) || this.label.length === 0) {
     this.fetchLabels().then((labelResponse: any) => {
       console.log(labelResponse);
       this.label = labelResponse;
        // console.log('first pragraph:'+this.label.EBIENNIAL_HOME_PARAGRAPH_1);
      });
    }
    console.log('imageFolderPath:' + this.imageFolderPath);
    this.ebiennialTransactionData = (this as any).$store.state.ebiennial.EbiennialTransactionData;
    console.log('getting data from store');
    console.log(this.ebiennialTransactionData);
    this.licenseSpeAppId = this.ebiennialTransactionData.licenseSpecAppId;
    this.ebiennialFixedData = this.ebiennialTransactionData.ebiennialFixedData;
    this.ebiennialFixedData = this.ebiennialTransactionData.ebiennialFixedData.replace(/(\\r)*\\n/g, '<br>')
    //console.log(JSON.stringify(this.ebiennialFixedData, null, 't'));
    //this.ebiennialFixedData = JSON.stringify(this.ebiennialFixedData, null, '\t')
    console.log('after replacing rn');
    console.log(this.ebiennialFixedData);
    console.log(JSON.stringify(this.ebiennialFixedData, null, '\t'));
  }
  private getLabelValue(keyPassed: string) {
    for (let i = 0; i < this.label.length; i++) {
      for (const key in this.label[i] ) {
        if (key === keyPassed) {
          console.log('Matched if');
          return this.label[i][key];
        }

      }
    }
    // console.log('label value:'+this.label[keyPassed]);
    // return this.label[keyPassed];
  }
  private getImageURL(columnname: string) {
     const images = require.context('@/assets/images/', true, /\.jpg$/);
     return images('./' + this.getLabelValue(columnname));
    // return this.getLabelValue(columnname);
  }
  private fetchLabels() {
     // return this.$http.get('Ebiennial/GetConfigurationData', {
      //  return genericapi.get('Ebiennial/GetConfigurationData', {
        return genericapi.get('Generic/GetConfigurationData', {
          params: {
          group: 'SECTION',
          application: 'EBIENNIAL',
      },

    }).then((response: any) => {
      console.log(response);

      // console.log('key value:'+response.data.values[response.data.map(function(o) { return o.key; }).indexOf('EBIENNIAL_HOME_PARAGRAPH_1')]);
      return response.data;
    }).catch((error: any) => {
      console.log(error);
    });
  }
  private submitEbiennial(): void {
    const store = this.$store;
    const http = this.$http;
    this.errors.length = 0;
    if (this.empty(this.ebiennialFixedData)) {
      console.log('Ebiennial request missing');
      this.errors.push('Ebiennial request missing.');
    }
    if (this.errors.length) {
   console.log('Missing values');
   return;
  }

// http.post('ebiennial/getBbiennial', {
    http.post('EbiennialFix/EBiennialDataFixFiling', {
      eBiennialDataFixFilingRequest: {
          licenseSpecAppId: this.licenseSpeAppId,
          ebiennialFixedData: this.ebiennialFixedData,
        },
    }).then((response: any) => {
      console.log(response.data);
      response = response.data.ebiennialFilingResult;
      if (response.requestStatus === 'Success') {
        this.errors.push(this.licenseSpeAppId+' License spec app id has been successfully processed');
      }else{
        this.errors.push(' There was a problem while processing License spec app id '+this.licenseSpeAppId);
      }

      //response = response.data.eBiennialSearchResult;
      //console.log(response);
      //store.commit("ebiennial/setEbiennialTransactionData", response.data);
      // console.log(response.filingData);
      //console.log('isSuccess:' + response.requestStatus);
      // store.commit('ebiennial/setEBiennialData', response.filingData);


    }).catch((error: any) => {
      // this.error = error
      console.log(error);
      this.errors.push(error);
    });
  }
    private EbiennialFixSearch(): void {
    (this as any).$router.push({ name: "fixSearch"});
  }

    private reset(): void {
        this.errors.length = 0;
        this.licenseSpeAppId = '';
        //this.BusinessName = '';
    return;
   }
    private empty(e) {
    switch (e) {
      case '':
      case '':
      case 0:
      case '0':
      case null:
      case false:
      case typeof this === 'undefined':
      case typeof this === undefined:
      return true;
      default:
        return false;
    }
  }
 }
